import ReactPixel from "react-facebook-pixel"
import ReactGA from "react-ga4"
import { canTrackMarketing } from "@reactiveonline/frontend_shared_components/utils"
import { getTranslatableField } from "./utils"

export function loadServicesListAnalytics(services, appProps) {
  if (canTrackMarketing()) {
    ReactPixel.trackCustom('ViewContent', {
      name: [ `${ services.map((service) => `${service.title}`)}`],
    })
  }
}

export function loadServiceViewAnalytics(service, appProps) {
  if (canTrackMarketing()) {
    ReactPixel.trackCustom('ViewContent', {
      name:     getTranslatableField(service, 'title', appProps.currentLocale, false),
      value:    service.price,
      currency: appProps.currency
    })
  }
}
